// ============================================
// INFRASTRUCTURE - Tours Vistos Repository
// ============================================
// Persistencia en backend de qué tours de producto ya vio el usuario —
// sobrevive a borrar localStorage o cambiar de navegador/dispositivo.

import { axiosClient } from './axios-client';

export const toursRepository = {
  /**
   * Tours ya vistos por el usuario autenticado actual, como "tourId:version".
   * GET /tours/vistos
   */
  async obtenerVistos(): Promise<string[]> {
    const { data } = await axiosClient.get<string[]>('/tours/vistos');
    return data;
  },

  /**
   * Marca un tour como visto para el usuario autenticado actual.
   * POST /tours/vistos
   */
  async marcarVisto(tourId: string, version: string): Promise<void> {
    await axiosClient.post('/tours/vistos', { tourId, version });
  },
};
